import { graphql, Link as GatsbyLink } from 'gatsby'
import React from 'react'
import { BoxArrowInUpRight as Arrow } from 'react-bootstrap-icons'

type Props = {
  to: string
  openInNewWindow?: boolean
  children: React.ReactNode | undefined | null
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  [x: string]: any
}
const Link: React.FC<Props> = ({
  to,
  openInNewWindow = false,
  children,
  ...props
}) => {
  if (!to) return children
  const isInternalURL = (to: string): boolean => {
    try {
      const url = new URL(to, window.location?.origin)
      return url.hostname === window.location?.hostname
    } catch {
      return false
    }
  }
  const target = openInNewWindow ? { target: '_blank' } : {}
  const rel = openInNewWindow ? { rel: 'noopener' } : {}
  if (isInternalURL(to)) {
    // Consistent trailing slashes on all URLs.
    const url = new URL(to, window?.location?.origin)
    if (!url.pathname.endsWith('/')) {
      url.pathname += '/'
    }
    const urlWithSlash = url.pathname + url.hash + url.search
    return (
      <GatsbyLink
        to={urlWithSlash}
        data-cy="link"
        {...target}
        {...rel}
        {...props}
      >
        {children}
      </GatsbyLink>
    )
  }

  return (
    <a href={to} data-cy="link" {...target} {...rel} {...props}>
      {children}
      {openInNewWindow && (
        <Arrow
          style={{ marginLeft: '5px', marginBottom: '5px' }}
          aria-label="Open in new window"
        />
      )}
    </a>
  )
}
export default Link

export const query = graphql`
  fragment PctLink on DatoCmsPctLink {
    __typename

    id: originalId
    externalName
    codeId
    url
    description
    openInNewWindow
    icon {
      url
    }
    linkType
    linkMedia {
      url
    }
    hash
    content {
      __typename
      ... on DatoCmsPctPaper {
        id
        slug
      }
      ... on DatoCmsPctDialog {
        id
        slug
      }
      ... on DatoCmsPctTopic {
        id
        slug
      }
      ... on DatoCmsPctTag {
        id
        slug
      }
      ... on DatoCmsPctInternalPage {
        id
        slug
      }
      ... on DatoCmsPctPage {
        id
        slug
      }
      ... on DatoCmsPctProject {
        id
        slug
      }
      ... on DatoCmsPctPost {
        id
        slug
      }
      ... on DatoCmsPctVision {
        id
        slug
      }
      ... on DatoCmsPctReport {
        id
        slug
      }
      ... on DatoCmsPctEpisode {
        id
        slug
      }
      ... on DatoCmsPctEvent {
        id
        slug
      }
    }
  }
`
